import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';

import { LogService } from './log.service';
import { Log } from './log';

import { PER_PAGE } from './../constante';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css'],
  providers: [LogService]
})
export class LogsComponent implements OnInit {
  titulo: string = "Logs";
  public logs: Log[];
  public busy: Promise<any>;
  public paginaAtual: number = 1;
  public itensPorPagina: number = PER_PAGE;
  public totalItens: number = 1;
  public params:any = {page: undefined, per_page: undefined};

  getLogs(): void {
    this.params['page'] = this.paginaAtual;
    this.busy = this.logService.getLog(this.params)
      .then(logs => this.carregar(logs));
  }


  carregar(logs: any): void{
    this.logs = logs.data;
    this.paginaAtual = logs.current_page;
    this.totalItens = logs.total;
    this.itensPorPagina = logs.per_page;
  }

  constructor( private logService: LogService) { }

  ngOnInit() {
    this.getLogs();
  }

  pageChanged(page: any): void{
    this.paginaAtual = page;
    this.getLogs();
  }
}



// WEBPACK FOOTER //
// ./src/app/logs/logs.component.ts